import PaymentIcon from '@mui/icons-material/Payment'
import { Box, Button, Card, CardActions, Container, Dialog, FormControl, FormLabel, Grid, LinearProgress, Typography } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import React from 'react'
import { Route, Switch, withRouter } from "react-router-dom"
import { CreditCardFrame, Heading } from '../components'
import { withAppContext } from '../context/AppContextProvider'
import NotFound from './404'

const styles = (theme) => ({
    box: {
        marginTop: theme.spacing(3),
    },
    marginAbove: {
        marginTop: theme.spacing(2),
    },
    cardContent: {
        padding: 0,
    },
    nested: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    noBorderBottom: {
        borderBottom: 0,
        paddingBottom: 0,
    },
    dialogText: {
        padding: theme.spacing(2),
    },
    paymentCard: {
        marginTop: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        paddingBottom: theme.spacing(2),
    },
})

class AddPaymentInformation extends React.Component {
    state = {
        waits: 1,
        processorSettings: null,
        token: null,
        expiry: null,
        last4: null,
        type: null,
        extraData: null,
        submitting: false,
    }

    componentDidMount = async () => {
        await this.getProcessorSettings()

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    getProcessorSettings = async () => {
        await this.setState({
            waits: this.state.waits + 1,
        })

        try {
            const { processorSettings } = await this.props.socket.send('addPaymentMethod', {
                step: 'getProcessorSettings',
            })

            await this.setState({
                processorSettings,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    isSubmittable = () => {
        const { token } = this.state

        // credit card information not provided
        if (!token) {
            return false
        }

        return true
    }

    handleTokenize = (token, expiry, last4, type, extraData, saveCard) => {
        this.setState({
            token,
            expiry,
            last4,
            type,
            extraData,
        })
    }

    handlePaymentChangeCard = () => {
        this.setState({
            token: null,
            expiry: null,
            last4: null,
            type: null,
            extraData: null,
        })
    }

    handleSubmit = async (customerId) => {
        const { match } = this.props
        const { token, expiry, last4, type, extraData } = this.state

        await this.setState({
            submitting: true,
        })

        try {
            const response = await this.props.socket.send('addPaymentMethod', {
                step: 'addPaymentMethod',
                customerId,
                token,
                expiry,
                last4,
                type,
                extraData,
            })

            this.props.showMessage(response, {
                variant: 'success',
                persist: true,
                // eslint-disable-next-line react/display-name
                action: (key) => <Button onClick={() => { this.props.closeSnackbar(key) }}>Dismiss</Button>,
            })

            // inform parent window if used within iframe
            window.parent.postMessage({
                wylieScript: 'portal',
                paymentMethodAdded: true,
            }, '*')

            this.props.history.push(`${match.url}/success`)

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            submitting: false,
        })
    }

    render = () => {
        const { classes, match, features } = this.props
        const { processorSettings, token, last4, submitting, waits } = this.state
        const { path } = match

        if (waits > 0) {
            return (
                <Container maxWidth="lg">
                    <LinearProgress className={classes.marginAbove} />
                </Container>
            )
        }

        return (
            <Switch>
                <Route path={`${path}/c-:customerId`} exact render={({ match: subMatch }) => {
                    const { customerId } = subMatch.params

                    return <>
                        <Container maxWidth="sm">
                            <Heading icon={<PaymentIcon />}>
                                Add Payment Information
                            </Heading>

                            <Card className={classes.paymentCard}>
                                <FormControl variant="standard" className={classes.marginAbove} fullWidth>
                                    <FormLabel>Securely add your payment information to file using the form below</FormLabel>
                                </FormControl>

                                {!!token &&
                                    <CreditCardFrame
                                        className={classes.marginAbove}
                                        processor={features.payment}
                                        locked={true}
                                        last4={last4}
                                        onChangeCard={this.handlePaymentChangeCard}
                                    />
                                }

                                {!token &&
                                    <CreditCardFrame
                                        className={classes.marginAbove}
                                        processor={features.payment}
                                        processorSettings={processorSettings}
                                        locked={false}
                                        last4={last4}
                                        paymentSaveCard={true}
                                        forceSaveCard={true}
                                        saveCardLabel="Save card on file (required)"
                                        onTokenize={this.handleTokenize}
                                        onChangeCard={this.handlePaymentChangeCard}
                                    />
                                }

                                <CardActions>
                                    <Grid container justifyContent="flex-end">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            startIcon={<PaymentIcon />}
                                            onClick={() => { this.handleSubmit(customerId) }}
                                            disabled={!this.isSubmittable()}
                                        >
                                            Submit
                                        </Button>
                                    </Grid>
                                </CardActions>
                            </Card>

                            <Dialog open={submitting}>
                                <Typography className={classes.dialogText}>Submitting request, please wait...</Typography>
                            </Dialog>
                        </Container>
                    </>
                }} />

                <Route path={`${path}/success`} exact>
                    <Container maxWidth="sm">
                        <Heading icon={<PaymentIcon />}>
                            Add Payment Information
                        </Heading>

                        <Box spacing={2} className={classes.box}>
                            <Typography paragraph>Thank you for adding your payment information! You may close this page.</Typography>
                        </Box>
                    </Container>
                </Route>

                {/* 404 Not Found */}
                <Route>
                    <NotFound homePath={this.props.paths.root} />
                </Route>
            </Switch>
        )
    }
}

export default withAppContext(withRouter(withStyles(styles, { withTheme: true })(AddPaymentInformation)))
